import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useLeadStatusGuard } from "@/features/lead/components/lead-status-guard-context";
import { LEAD_STATUSES, LEAD_STATUS_LABELS } from "@/features/lead/constants";
import type { Lead, LeadStatus } from "@/features/lead/types";

interface LeadStatusSelectProps {
  lead: Lead;
}

/**
 * Mobile-mode status changer. Renders next to the lead card body so the
 * brokerage's agents — who work from phones — can move a card between
 * pipeline stages without drag-drop ergonomics (which feel bad on touch).
 *
 * <p>The actual patch (or the "create an appointment first" modal) is
 * handled by the {@link LeadStatusGuardProvider} the page mounts. Keeping
 * the logic in the provider means the kanban drag-handler and this
 * Select stay in sync on rule changes.
 */
export function LeadStatusSelect({ lead }: LeadStatusSelectProps) {
  const guard = useLeadStatusGuard();

  const handleChange = (next: string) => {
    guard.requestStatusChange(lead, next as LeadStatus);
  };

  return (
    <Select
      value={lead.status}
      onValueChange={handleChange}
      disabled={guard.isPending}
    >
      <SelectTrigger className="h-8 w-full text-xs" aria-label="Chuyển trạng thái">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {LEAD_STATUSES.map((s) => (
          <SelectItem key={s} value={s} className="text-xs">
            {LEAD_STATUS_LABELS[s]}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
